/**
 * The icon beside each row of the website's Specifications card
 * (lib/config/productSpecs.ts#specRowsFor gives the rows). The shop's own
 * details and anything new get the info icon.
 */

import type { ComponentType } from "react";
import { Battery, Camera, Cpu, HardDrive, Info, Monitor, Shield, Smartphone, Wifi, Zap } from "lucide-react";

const ICONS: Record<string, ComponentType<{ className?: string }>> = {
  brand: Info,
  model: Smartphone,
  modelNumber: Smartphone,
  processor: Cpu,
  ram: Zap,
  storage: HardDrive,
  os: Monitor,
  screenSize: Monitor,
  screenType: Monitor,
  resolution: Monitor,
  refreshRate: Monitor,
  battery: Battery,
  chargingSpeed: Zap,
  chargingPort: Zap,
  camera: Camera,
  connectivity: Wifi,
  simType: Smartphone,
  waterResistance: Shield,
  warranty: Shield,
  connectionType: Wifi,
  powerOutput: Zap,
};

export function specIcon(key: string) {
  const Icon = ICONS[key] ?? Info;
  return <Icon className="w-4 h-4" />;
}
